import {AND, ARRAY, INTEGER, OBJECT, OPTIONAL, STRING} from '@acng/frontend-rubicon';
import {GALLERY_DATA} from '../../core/service/guard.js';
import {FSK_LEVEL} from '../../core/model/fsk.js';

export const MOVIE_DATA = /* @__PURE__ */ AND(
  GALLERY_DATA,
  /* @__PURE__ */ OBJECT({
    id: INTEGER,
    fsk: FSK_LEVEL,
    filesize: INTEGER,
    playtime: INTEGER,
    width: INTEGER,
    height: INTEGER,
    movie_previews: OPTIONAL(ARRAY(STRING)),
  })
);
